exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bot-upload-images .v-image {\n  cursor: pointer;\n  border-style: inset;\n  border-width: 3px;\n  border-color: #ff7f50;\n}\n.bot-upload-images figure figcaption {\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/bot/upload/bot.upload.images.vue?vue&type=style&index=0&id=f8afbc30&lang=stylus&
// module id = 723
// module chunks = 1 7